module.exports = __webpack_public_path__ + "media/webfonts/fa-brands-400-1d5619cd.svg";